
import { getReplenishmentReportCsv } from '../api/getReplenishmentReportCsv';

const setGetReplenishmentReportCsv = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const {data} = await getReplenishmentReportCsv(params);
            
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'data.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReplenishmentReportCsv
}